//Angular components
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

//App components
import { CompanyStatus } from 'src/app/app.data';
import { Company } from 'src/app/_shared/models';

@Component({
  selector: 'app-pending-activation',
  templateUrl: './pending-activation.component.html',
  styleUrls: ['./pending-activation.component.scss']
})
export class PendingActivationComponent {

  @Input() collectionOfPendingCompanies: Array<Company> = [];
  @Input() hasMessage: boolean = false;
  @Input() _companyStatus = CompanyStatus;

  constructor(private router: Router) { }

  activateCompany(companyData: any) {
    this.router.navigate([`setup/company/${companyData.id}/activate`]);
  }
}
